(ns quuppa.qsm.events
  (:require [clojure.string :as str]
            [re-frame.core :as rf]
            [potpuri.core :as p]
            [quuppa.peweb.connection :refer [send-event]]
            [quuppa.peweb.query :as q]
            [quuppa.peweb.confirm]
            quuppa.qsm.qpe-boot-events))

(rf/reg-fx
  :server-dispatch
  (fn [event-or-map]
    (send-event event-or-map)))

;; On QPE just send event as is,
;; in QSM wrap with qpe/command event and qpe-identity.
(rf/reg-fx
  :qpe-dispatch
  (fn [{:keys [qpe-identity event qpe-timeout-ms site-id] :as data}]
    (send-event (assoc data :event [:qpe/command (p/assoc-if
                                                   {:event event}
                                                   :qpe-identity   qpe-identity
                                                   :site-id        site-id
                                                   :qpe-timeout-ms qpe-timeout-ms)]))))

(rf/reg-fx
  :document/title
  (fn [new-title]
    (set! (.-title js/document) new-title)))

;; TODO: Subscription parameters?
;; Currently same as connected query? Not perfect but enough maybe?
;; Once we have query + subscription registry, could be handled there.

;; note, authorized QPEs are indexed by :identity
(def authorized-qpes
  (q/create-query :authorized-qpes/all []))

;; note, preconfigured QPEs are indexed by db :id
(def configured-qpes
  (q/create-query :preconfigured-qpes/all []))

(rf/reg-event-db
  :qpe/add
  (fn [db event]
    ;; Update both query results using the same event.
    (-> db
        ((q/update-event-fn authorized-qpes (fn [result qpe]
                                              (assoc result (:identity qpe) qpe)))
         event)
        ((q/update-event-fn configured-qpes (fn [result qpe]
                                              (dissoc result (:id qpe))))
         event))))

(rf/reg-event-db
  :qpe/revoked-authorization
  (q/update-event-fn authorized-qpes (fn [result event]
                                       (dissoc result (:identity event)))))

(rf/reg-event-fx
  :qpe/status
  (fn [{:keys [db]} [_ data :as event]]
    (let [query       authorized-qpes
          prev-status (get-in (q/get-result db query {}) [:result (:identity data) :status])]
      {:db ((q/update-event-fn query
                               (fn [result event]
                                 (assoc-in result [(:identity event) :status] (:status event))))
            db
            event)
       :fx [[:dispatch [:qpe/status-changed (:identity data) {:from prev-status
                                                              :to   (:status data)}]]]})))

(rf/reg-event-db
  :qpe/update
  (q/update-event-fn authorized-qpes (fn [result qpe]
                                       (update result (:identity qpe) merge qpe))))

(rf/reg-event-fx
  :qpe/deleted
  (fn [_ [{qpe-id :id qpe-name :name :as qpe}]]
    ;; As QPEs are currently separated to two "buckets", preconfigured & authorized
    ;; both of the queries have their own state, thus when QPE gets truly deleted from
    ;; database we currently make sure here that it gets removed from both buckets.
    ;; Previously it was only handled by separating states directly in registration 'sidebar-form' component
    {:fx [[:dispatch [:qpe/registration-deleted qpe-id]]
          [:dispatch [:qpe/revoked-authorization qpe]]
          [:dispatch [:notifications/notify-success {:message (str qpe-name " removed")}]]]}))

;;
;; Configured qpes subs
;;

(rf/reg-event-db
  :qpe/registration-deleted
  (q/update-event-fn configured-qpes (fn [result qpe-id]
                                       (dissoc result qpe-id))))

(rf/reg-event-db
  :qpe/preconfigured
  (q/update-event-fn configured-qpes (fn [result qpe]
                                       (assoc result (:id qpe) qpe))))

(rf/reg-event-db
  :qpe/installation-token-refreshed
  (q/update-event-fn configured-qpes (fn [result qpe]
                                       (update result (:id qpe) merge qpe))))

(rf/reg-sub
  :qpe/active-qpe
  :<- [:nav/match]
  (fn [route _]
    (-> route :parameters :path :qpe-identity)))

(rf/reg-event-fx
  :qpe/status-changed
  (fn [_ [_ _qpe-identity {:keys [from to]}]]
    (when (and (= "upgrading" from)
               (= "online" to))
      {:fx [[:dispatch [:notifications/notify
                        {:id         :qpe-back-online
                         :timeout-ms 5000
                         :type       :warning
                         :heading    "QPE back online"}]]]})))

(rf/reg-event-fx
  :qsm/poison-pill
  (fn [_ _]
    (js/console.warn "QSM send us poison pill, reloading page")
    {:fx [[:dispatch [:user/signout-user]]]}))

(rf/reg-event-fx
  :nav/subscriptions
  (fn [_ [_ subscriptions]]
    {:fx [[:server-dispatch [:qsm/set-subscriptions subscriptions]]]}))


(rf/reg-event-fx
  :qsm/delete-qpe
  (fn [_ [_ qpe-id]]
    {:fx [[:dispatch [:confirm/open {:message "Are you sure want to remove this QPE? Information about this QPE will be lost."
                                     :ok-label "Delete"
                                     :on-confirm [:qpe/delete-qpe-registration qpe-id]}]]]}))

(rf/reg-sub :qsm/qpe-feature-supported
  (fn [[_ qpe-identity]]
    (q/subscribe authorized-qpes {} [:result qpe-identity :features]))
  (fn [features [_ _qpe-identity feature-k]]
    (contains? features feature-k)))

(rf/reg-event-db ::sidebar-toggle
  (fn [db _]
    (update db :sidebar-open not)))

(rf/reg-sub ::sidebar-open
  (fn [db]
    (:sidebar-open db)))

(rf/reg-event-fx ::root-start
  (fn [{:keys [db]} _]
    (when (and (:session db)
               (str/includes? (.-title js/document) "Welcome"))
      ;; after logging in, clear the 'Welcome' title of the landing page
      {:fx [[:document/title "QSM"]]})))
